(() => {
  if (window.__FAJ_SERVICE_FAQ_ACCORDION_V3__) return;
  window.__FAJ_SERVICE_FAQ_ACCORDION_V3__ = true;

  const getDuration = (section) => {
    const duration = Number(section?.dataset.animationDuration || 350);
    return Number.isFinite(duration) ? duration : 350;
  };

  const clearPanelTimer = (panel) => {
    if (panel?._fajmfqTimer) {
      window.clearTimeout(panel._fajmfqTimer);
      panel._fajmfqTimer = null;
    }
  };

  const setPanelHeightToAuto = (panel, duration) => {
    clearPanelTimer(panel);

    panel._fajmfqTimer = window.setTimeout(() => {
      if (panel.closest('[data-fajmfq-item]')?.classList.contains('is-open')) {
        panel.style.height = 'auto';
      }

      panel._fajmfqTimer = null;
    }, duration);
  };

  const openItem = (item, section, instant = false) => {
    const trigger = item.querySelector('[data-fajmfq-trigger]');
    const panel = item.querySelector('[data-fajmfq-panel]');
    if (!panel) return;

    clearPanelTimer(panel);

    item.classList.add('is-open');
    trigger?.setAttribute('aria-expanded', 'true');
    panel.hidden = false;

    if (instant) {
      panel.style.height = 'auto';
      panel.style.opacity = '1';
      panel.style.visibility = 'visible';
      return;
    }

    panel.style.height = '0px';
    panel.style.opacity = '0';
    panel.style.visibility = 'visible';

    window.requestAnimationFrame(() => {
      panel.style.height = `${panel.scrollHeight}px`;
      panel.style.opacity = '1';
      setPanelHeightToAuto(panel, getDuration(section));
    });
  };

  const closeItem = (item, section, instant = false) => {
    const trigger = item.querySelector('[data-fajmfq-trigger]');
    const panel = item.querySelector('[data-fajmfq-panel]');
    if (!panel) return;

    clearPanelTimer(panel);

    trigger?.setAttribute('aria-expanded', 'false');

    if (instant) {
      item.classList.remove('is-open');
      panel.style.height = '0px';
      panel.style.opacity = '0';
      panel.style.visibility = 'hidden';
      panel.hidden = true;
      return;
    }

    if (panel.style.height === 'auto' || !panel.style.height) {
      panel.style.height = `${panel.scrollHeight}px`;
    }

    panel.style.opacity = '1';
    panel.style.visibility = 'visible';

    window.requestAnimationFrame(() => {
      item.classList.remove('is-open');
      panel.style.height = '0px';
      panel.style.opacity = '0';

      panel._fajmfqTimer = window.setTimeout(() => {
        if (!item.classList.contains('is-open')) {
          panel.style.visibility = 'hidden';
          panel.hidden = true;
        }

        panel._fajmfqTimer = null;
      }, getDuration(section));
    });
  };

  const initializeSection = (section) => {
    section.querySelectorAll('[data-fajmfq-item]').forEach((item) => {
      const panel = item.querySelector('[data-fajmfq-panel]');
      if (!panel) return;

      if (item.classList.contains('is-open')) {
        panel.hidden = false;
        panel.style.height = 'auto';
        panel.style.opacity = '1';
        panel.style.visibility = 'visible';
      } else {
        panel.style.height = '0px';
        panel.style.opacity = '0';
        panel.style.visibility = 'hidden';
        panel.hidden = true;
      }
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-fajmfq-trigger]');
    if (!trigger) return;

    const section = trigger.closest('[data-fajmfq]');
    const item = trigger.closest('[data-fajmfq-item]');
    if (!section || !item) return;

    const isOpen = item.classList.contains('is-open');
    const allowMultiple = section.dataset.allowMultiple === 'true';

    if (!allowMultiple && !isOpen) {
      section.querySelectorAll('[data-fajmfq-item].is-open').forEach(
        (openItemNode) => {
          if (openItemNode !== item) {
            closeItem(openItemNode, section);
          }
        }
      );
    }

    if (isOpen) {
      closeItem(item, section);
    } else {
      openItem(item, section);
    }
  });

  const initAll = (root = document) => {
    if (root.matches?.('[data-fajmfq]')) {
      initializeSection(root);
    }

    root.querySelectorAll?.('[data-fajmfq]').forEach(initializeSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
